import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { Content, ContentVisualizationType } from '../../../../domain/content/content.model';
import { UrlCleanPipe } from '../../../util/pipes/url-clean/url-clean.pipe';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { NgClass, NgStyle, DatePipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

interface CardCss {
  cardFlexDirection: string;
  card: string;
  img: string;
  title: string;
  subtitle: string;
  eyelet: string;
  actionDiv: string;
  action: string;
  imageFxFlex: string;
  showImage: boolean;
  showAction: boolean;
  leftside: string;
}

interface CardVisualization {
  visualizationType: ContentVisualizationType;
  cssClasses: CardCss;
}

const CARD_VISUALIZATIONS: CardVisualization[] = [
  {
    visualizationType: ContentVisualizationType.ListCard,
    cssClasses: {
      cardFlexDirection: 'row',
      card: 'list-card',
      img: 'list-img',
      title: 'dottnet-card-title list-title',
      subtitle: 'dottnet-card-subtitle',
      eyelet: 'dottnet-card-eyelet list-eyelet',
      actionDiv: 'list-action-div',
      action: 'list-action',
      imageFxFlex: '25',
      showImage: true,
      showAction: true,
      leftside: 'left-side'
    }
  },
  {
    visualizationType: ContentVisualizationType.NoImageCard,
    cssClasses: {
      cardFlexDirection: 'row',
      card: 'noimage-card',
      img: '',
      title: 'dottnet-card-title noimage-title',
      subtitle: 'dottnet-card-subtitle',
      eyelet: 'dottnet-card-eyelet noimage-eyelet',
      actionDiv: '',
      action: '',
      imageFxFlex: '0',
      showImage: false,
      showAction: false,
      leftside: ''
    }
  },
  {
    visualizationType: ContentVisualizationType.NoImageCardHome,
    cssClasses: {
      cardFlexDirection: 'row',
      card: 'noimage-card-home',
      img: '',
      title: 'dottnet-card-title noimage-title pointer-underline-hover',
      subtitle: 'dottnet-card-subtitle',
      eyelet: 'dottnet-card-eyelet noimage-eyelet',
      actionDiv: '',
      action: '',
      imageFxFlex: '0',
      showImage: false,
      showAction: false,
      leftside: ''
    }
  },
  {
    visualizationType: ContentVisualizationType.NoImageCardColumn,
    cssClasses: {
      cardFlexDirection: 'row',
      card: 'noimage-column-card',
      img: '',
      title: 'dottnet-card-title noimage-column-title',
      subtitle: 'dottnet-card-subtitle',
      eyelet: 'dottnet-card-eyelet noimage-column-eyelet',
      actionDiv: '',
      action: '',
      imageFxFlex: '0',
      showImage: false,
      showAction: false,
      leftside: ''
    }
  },
  {
    visualizationType: ContentVisualizationType.OnlyTitleCard,
    cssClasses: {
      cardFlexDirection: 'row',
      card: 'onlytitle-card',
      img: '',
      title: 'dottnet-card-title onlytitle-title',
      subtitle: '',
      eyelet: 'dottnet-card-eyelet noimage-column-eyelet',
      actionDiv: '',
      action: '',
      imageFxFlex: '0',
      showImage: false,
      showAction: false,
      leftside: ''
    }
  },
  {
    visualizationType: ContentVisualizationType.ListCardDxColumn,
    cssClasses: {
      cardFlexDirection: 'column',
      card: 'list-card-dx',
      img: 'list-img-dx',
      title: 'dottnet-card-title list-title-dx',
      subtitle: 'dottnet-card-subtitle',
      eyelet: 'dottnet-card-eyelet list-eyelet-dx',
      actionDiv: '',
      action: 'list-action',
      imageFxFlex: '100',
      showImage: true,
      showAction: false,
      leftside: ''
    }
  },
  {
    visualizationType: ContentVisualizationType.VideoCardDxColumn,
    cssClasses: {
      cardFlexDirection: 'column',
      card: 'list-card-dx',
      img: 'list-video-img',
      title: 'dottnet-card-title list-title-dx',
      subtitle: 'dottnet-card-subtitle',
      eyelet: '',
      actionDiv: '',
      action: '',
      imageFxFlex: '100',
      showImage: true,
      showAction: false,
      leftside: ''
    }
  },
  {
    visualizationType: ContentVisualizationType.RubricaCard,
    cssClasses: {
      cardFlexDirection: 'column',
      card: 'rubrica-card',
      img: '',
      title: 'rubrica-card-title dottnet-rubrica pointer-underline-hover',
      subtitle: '',
      eyelet: '',
      actionDiv: '',
      action: '',
      imageFxFlex: '100',
      showImage: false,
      showAction: false,
      leftside: ''
    }
  }
];

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'dottnet-generic-card',
  templateUrl: 'generic-card.component.html',
  styleUrls: ['./generic-card.component.scss', '../../content-list-viewer.component.scss'],
  imports: [MatCardModule, NgClass, NgStyle, RouterLink, MatButtonModule, DatePipe, UrlCleanPipe, MatIconModule]
})
export class GenericCardComponent implements OnInit {
  readonly ContentVisualizationType = ContentVisualizationType;

  readonly content = input<Content>(undefined);
  readonly buttonAction = input<string>(undefined);
  readonly visualizationType = input<ContentVisualizationType>(undefined);

  cssClasses: CardCss;

  constructor() { }

  ngOnInit(): void {
    [this.cssClasses] = CARD_VISUALIZATIONS.filter(
      (elem) => elem.visualizationType === this.visualizationType()
    ).map((elem) => elem.cssClasses);
  }
}
